var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"input-img-bg",on:{"click":_vm.add_img}},[_c('input',{staticStyle:{"width":"0","height":"0"},attrs:{"id":"file-img","type":"file","accept":"image/*"},on:{"change":_vm.onFileChange}}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"input-img-intext",attrs:{"for":"file-img"}},[_c('i',{staticClass:"material-icons"},[_vm._v("attach_file")])])
}]

export { render, staticRenderFns }